import { combineReducers } from "@reduxjs/toolkit";

import { AddressValidation } from "./AddressValidation";
import { DuplicateCheck } from "./DuplicateCheck";

export const Omikron = combineReducers({
  av: AddressValidation,
  dc: DuplicateCheck
});
